export class ExpiredSessionError extends Error {
  constructor() {
    super("User session has expired, please login again.");
  }
}
